import React from 'react';
import { AppBar } from 'react-admin';
import Menu from './Menu';

export const LayoutAppBar = props => <AppBar {...props} userMenu={<Menu />} />;
